import api from './axiosApi'

export interface SystemSettingRead {
  id: string
  setting_key: string
  value: string
  description: string | null
  updated_at: string
  updated_by: string
}

export interface SystemSettingsList {
  items: SystemSettingRead[]
}

export async function fetchSystemSettings(): Promise<SystemSettingsList> {
  const { data } = await api.get<SystemSettingsList>('/admin/system-settings')
  return data
}

export async function updateSystemSetting(
  settingKey: string,
  value: string
): Promise<SystemSettingRead> {
  const { data } = await api.patch<SystemSettingRead>(
    `/admin/system-settings/${settingKey}`,
    { value }
  )
  return data
}
